const axios = require('axios');

export function API(){
	return axios;
}
